import { InputLabel, ToggleButton, ToggleButtonGroup } from '@mui/material';
import styled, { css } from 'styled-components';

/** The field name above the control - the same label the shared Select draws above its input. */
export const Label = styled(InputLabel)`
  margin-bottom: 8px;
  font-weight: 700;
`;

export const Group = styled(ToggleButtonGroup)`
  display: inline-flex;
`;

/** The app's toggle (ui/daysSelector) laid out as a horizontal group: colours from the theme only. */
export const Option = styled(ToggleButton)(
  ({ theme: { palette } }) => css`
    border-color: ${palette.primary.main};
    color: ${palette.primary.main};

    &.Mui-selected {
      background-color: ${palette.primary.main};
      color: ${palette.common.white};

      &.Mui-disabled {
        background-color: ${palette.grey[600]};
      }

      &:hover {
        background-color: ${palette.primary.main};
      }
    }
  `,
);
